import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteCustomerOnboardingEmail($customerId: ID!) {
    deleteCustomerOnboardingEmail(customerId: $customerId) {
      success
    }
  }
`;

export const deleteCustomerOnboardingEmail = (customerId) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId },
  }).then(({ data }) => getSingleProp(data));
